const displayedStatuses = new Set([400, 403, 404, 409, 502]);

export default function getApiErrorMessage(
  error: unknown,
  fallback = 'Something went wrong',
): string {
  const response = (
    error as {
      response?: { status?: unknown; data?: { message?: unknown } };
    }
  )?.response;
  const status = typeof response?.status === 'number' ? response.status : 0;
  const message = response?.data?.message;

  if (displayedStatuses.has(status) && typeof message === 'string' && message) {
    return message;
  }

  return fallback;
}
